module.exports = __webpack_public_path__ + "static/media/Vector_Smart_Object3.57212d02.png";